import { getBuyerId } from 'dibs-cookie-jar';
import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';

import { canShowTradePromoModal, markModalSeen, isAtViewLimit } from './tradePromoHelpers';
import { TRADE_PROMO_CODES, BRONZE_LOANER_PROGRAM } from './constants';

const query = graphql`
    query tradePromoRule_Query($userId: String!) {
        viewer {
            user(userId: $userId) {
                tradeFirm {
                    rewards {
                        currentPromoSegment(userId: $userId) {
                            segmentCode
                            promotion {
                                code
                            }
                        }
                    }
                }
            }
        }
    }
`;

function queryTradePromo(relayEnvironment) {
    const userId = getBuyerId(document.cookie);
    return fetchQuery(relayEnvironment, query, { userId }).then(data => {
        const tradeFirmSegment = get(
            data,
            'viewer.user.tradeFirm.rewards.currentPromoSegment.segmentCode'
        );
        const isInBronzeLoanerSegment = tradeFirmSegment === BRONZE_LOANER_PROGRAM;
        const tradePromo = get(
            data,
            'viewer.user.tradeFirm.rewards.currentPromoSegment.promotion.code'
        );
        const shouldOpenModal =
            (isInBronzeLoanerSegment || TRADE_PROMO_CODES.includes(tradePromo)) &&
            !isAtViewLimit(isInBronzeLoanerSegment ? tradeFirmSegment : tradePromo);

        if (shouldOpenModal) {
            if (isInBronzeLoanerSegment) {
                markModalSeen(tradeFirmSegment);
            } else {
                markModalSeen(tradePromo);
            }
        }
        return shouldOpenModal;
    });
}

export function tradePromoRule({ relayEnvironment }) {
    if (canShowTradePromoModal()) {
        return queryTradePromo(relayEnvironment);
    }

    return Promise.resolve(false);
}
